<div class="td-indicators">
  <div class="td-indicators-header">
    <span class="td-indicators-title">{{ 'td_team_report_indicators' | translate }}</span>
    <span class="td-indicators-hint">{{ 'td_team_report_indicators_hint' | translate }}</span>
  </div>

  <div class="td-indicators-list">
    <div class="td-indicator" #indicatorRow
         *ngFor="let row of rows; let index = index; trackBy: trackByUuid">
      <p-accordion styleClass="td-indicator-accordion"
                   collapseIcon="bi bi-chevron-up" expandIcon="bi bi-chevron-down"
                   (onOpen)="onRowOpen(row)"
                   (onClose)="onRowClose(row)">
        <p-accordionTab [selected]="selectedTabs[index]"
                        transitionOptions="300ms cubic-bezier(.25,.8,.25,1)">
          <ng-template pTemplate="header">
            <div class="td-indicator-row">
              <span class="td-indicator-chip" [ngStyle]="{'background-color': row.color}">
                <span class="td-indicator-glyph"
                      [ngStyle]="{'-webkit-mask-image': 'url(' + row.icon + ')',
                                  'mask-image': 'url(' + row.icon + ')'}"></span>
              </span>
              <span class="td-indicator-name">{{ row.title }}</span>
              <span class="td-indicator-score">{{ row.score }}%</span>
              <p-chart type="doughnut" [data]="indicatorCharts[index]" [options]="chartOptions"
                       [responsive]="true" [style]="{'width': '5rem', 'margin-bottom':'1rem'}"></p-chart>
              <span class="td-indicator-trend" [ngClass]="row.trend ? row.trend : 'flat'">
                <img *ngIf="row.trend" [src]="'../../../assets/svg/indicator-arrow-' + row.trend + '.svg'" alt="">
                <i class="bi bi-dash-lg" *ngIf="!row.trend"></i>
                <span>{{row.trend ? row.diff:''}}%</span>
              </span>
            </div>
          </ng-template>
          <ng-template pTemplate="content">
            <div class="td-indicator-content">
              <div *ngIf="false" class="td-indicator-panels" [ngClass]="{'with-distribution': showDistribution}">
                <app-score-development class="td-indicator-chart"
                                       titleKey="td_indicator_score_over_time"
                                       [showChips]="false"
                                       [scores]="scores"
                                       [chips]="chartChips"
                                       [activeChipUuid]="openUuid"
                                       [loading]="loadingScores">
                </app-score-development>
                <div class="td-card td-distribution-card" *ngIf="showDistribution">
                  <div class="td-card-header">
                    <span class="td-card-title">{{ 'td_indicator_score_distribution' | translate }}</span>
                    <span class="td-distribution-meta">
                      {{ 'td_indicator_teams_count' | translate : {count: teamsTotal} }}
                    </span>
                  </div>

                  <div class="td-distribution-body">
                    <div class="td-distribution-bar">
                      <span class="td-distribution-segment"
                            *ngFor="let segment of distribution; trackBy: trackByColorName"
                            [ngStyle]="{'flex-grow': segment.percentage, 'background-color': segment.color}"
                            [pTooltip]="'td_indicator_teams_count' | translate : {count: segment.teams}"
                            tooltipPosition="top" tooltipStyleClass="tooltip-style td-tooltip"></span>
                    </div>
                    <div class="td-distribution-labels">
                      <span class="td-distribution-label"
                            *ngFor="let segment of distributionLabels; trackBy: trackByColorName"
                            [ngStyle]="{'flex-grow': segment.percentage, 'color': segment.color}">
                        {{ segment.percentage }}%
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <app-indicator-statements [data]="statements"
                                        [loading]="loadingStatements"
                                        [responses]="statementResponses"
                                        [periodStartDate]="periodStartDate"
                                        [periodEndDate]="periodEndDate"
                                        (filtersChanged)="onStatementFiltersChanged($event)"
                                        (statementOpened)="onStatementOpened($event)">
              </app-indicator-statements>
            </div>
          </ng-template>
        </p-accordionTab>
      </p-accordion>
    </div>
  </div>

  <span class="td-indicators-empty" *ngIf="!rows.length">{{ 'td_no_data' | translate }}</span>
</div>
